export const formatCurrency = (amount) => {
  if (!amount) return 'KES 0.00';
  return new Intl.NumberFormat('en-KE', {
    style: 'currency',
    currency: 'KES',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(amount);
};

export const formatDate = (date) => {
  if (!date) return 'N/A';
  const d = new Date(date);
  return new Intl.DateTimeFormat('en-KE', {
    year: 'numeric',
    month: 'short',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
  }).format(d);
};

export const formatDateShort = (date) => {
  if (!date) return 'N/A';
  const d = new Date(date);
  return new Intl.DateTimeFormat('en-KE', {
    year: 'numeric',
    month: 'short',
    day: '2-digit',
  }).format(d);
};

export const getTransactionTypeColor = (type) => {
  switch (type) {
    case 'Credit':
      return '#4caf50';
    case 'Debit':
      return '#f44336';
    case 'Both':
      return '#ff9800';
    default:
      return '#9e9e9e';
  }
};

export const getTransactionTypeIcon = (type) => {
  switch (type) {
    case 'Credit':
      return '↑';
    case 'Debit':
      return '↓';
    case 'Both':
      return '↕';
    default:
      return '•';
  }
};

export const truncateText = (text, maxLength = 50) => {
  if (!text) return '';
  if (text.length <= maxLength) return text;
  return text.substring(0, maxLength) + '...';
};